import { decode } from "@googlemaps/polyline-codec";

/** Decodes an encoded polyline string to Leaflet `[lat, lng][]` pairs. */
export function decodeGooglePolylineToLatLng(encoded: string): [number, number][] {
  if (!encoded || !encoded.trim()) return [];
  try {
    const tuples = decode(encoded);
    return tuples.map(([lat, lng]) => [lat, lng] as [number, number]);
  } catch {
    return [];
  }
}
